// Parser for design system gallery
// One file = one entry. Title is derived from displayNameFromPath, content is HTML.
import { DesignSystemGalleryItem } from '../types';
import { displayNameFromPath } from '../content/util';

function containsHtmlTags(code: string): boolean {
	const htmlTagPattern = /<[a-z][\s\S]*?>/i;
	return htmlTagPattern.test(code);
}

// Parses a single gallery file into a gallery item.
// The entire file content is HTML — title comes from the filename.
export function parseGalleryFile(
	path: string,
	content: string | null | undefined
): DesignSystemGalleryItem | null {
	if (!content || content.trim().length === 0) return null;
	const code = content.trim();

	return {
		path,
		title: displayNameFromPath(path, 'gallery'),
		code,
		isValidHtml: containsHtmlTags(code),
	};
}
